//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import errGif from '@/assets/401_images/401.gif';
export default {
  name: 'Page401',
  data: function data() {
    return {
      errGif: errGif + '?' + +new Date(),
      ewizardClap: 'https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646',
      dialogVisible: false
    };
  },
  methods: {
    back: function back(type) {
      if (type === 1) {
        this.$router.push({
          name: 'dashboard'
        });
      }
    }
  }
};